var map = {
	"./awareness/focus-bell.mp3": 78,
	"./awareness/singing-bowl.mp3": 5546,
	"./completion/task-done.mp3": 3105,
	"./countdown/countdown-beep.mp3": 277,
	"./countdown/soft-chime.mp3": 2870,
	"./transition/completion-chime.mp3": 6830,
	"./transition/double-tone-next.mp3": 6526,
	"./warning/early-alert.mp3": 8945,
	"./warning/overdue-alert.mp3": 1477,
	"./warning/soft-warning.mp3": 6097,
	"./warning/time-up.mp3": 5688
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2999;